import { Component, Input } from '@angular/core';

import { ModalTypeComponent } from '../modal-type.shared.component';

@Component({
    selector: 'shared-modal-type-dynamic-height',
    templateUrl: './modal-type-dynamic-height.shared.component.html',
    styleUrls: ['./modal-type-dynamic-height.shared.component.scss'],
})
export class ModalTypeDynamicHeightComponent extends ModalTypeComponent {
    @Input() public dynamicHeight: boolean = true;
    @Input() public hasSpecialInstructions: boolean = true;

    constructor() {
        super();
    }
}
